import { render, staticRenderFns } from "./input-select-widget.vue?vue&type=template&id=db5625b2"
import script from "./input-select-widget.vue?vue&type=script&lang=js"
export * from "./input-select-widget.vue?vue&type=script&lang=js"
import style0 from "./input-select-widget.vue?vue&type=style&index=0&id=db5625b2&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db5625b2')) {
      api.createRecord('db5625b2', component.options)
    } else {
      api.reload('db5625b2', component.options)
    }
    module.hot.accept("./input-select-widget.vue?vue&type=template&id=db5625b2", function () {
      api.rerender('db5625b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/field-widget/input-select-widget.vue"
export default component.exports